<template>
  <div class="child_wrap">
    <Form :ref="'form' + current" :model="form" :rules="rules" :label-width="175">
      <Divider orientation="left">同住子女信息 </Divider>
      <Row>
        <Col span="24">
        <Alert show-icon closable>请填写需要享受积分相关待遇的<span style="color:red;font-weight: 900;">亲生</span>同住子女信息。</Alert>
        </Col>
      </Row>
      <template v-for="(item, index) in form.childrenList">
        <div class="childBox_childPage" :key="index">
          <span class="removeIcon" v-show="form.childrenList.length > 1" @click="delChild('childrenList', index)">
            <Icon type="md-close" size="20" color="#ffffff" />
          </span>
          <Row :gutter="16">
            <Col span="12">
            <FormItem :label="'子女' + (index + 1) + '姓名'" :prop="'childrenList[' + index + '].name'" :rules="{ required: true, message: '请输入', trigger: 'change' }">
              <Input v-model.trim="form.childrenList[index].name" :maxlength="40" placeholder="请输入">
              </Input>
            </FormItem>
            </Col>
            <Col span="12">
            <FormItem :label="'子女' + (index + 1) + '身份证号'" :prop="'childrenList[' + index + '].idCardNo'"
              :rules="[{ required: true, message: '请输入', trigger: 'change' },{ pattern: /^[1-9]\d{5}(18|19|20)\d{2}((0[1-9])|(1[0-2]))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/,message: '请输入正确的身份证号', trigger: 'blur' }]">
              <Input v-model.trim="form.childrenList[index].idCardNo" :maxlength="40" @on-blur="getChildAge('form' + current,index)" placeholder="请输入">
              </Input>
            </FormItem>
            </Col>
            <Col span="12">
            <FormItem :label="'子女' + (index + 1) + '年龄'" :prop="'childrenList[' + index + '].age'" :rules="{
                required: true,
                type: 'number',
                message: '请输入',
                trigger: 'change',
              }">
              <Input type="number" disabled v-model.trim.number="form.childrenList[index].age" placeholder="根据身份证自动识别">
              </Input>
            </FormItem>
            </Col>
            <!-- 选择配偶 -->
            <Col span="24">
            <Row>
              <Col span="24">
              <FormItem :label="'子女'+(idcardGetSexInInfo(form.applicantIDCardNo))" :prop="'childrenList[' + index + '].applicationSpouseId'" :rules="{
                    required: true,
                    message: '请选择',
                    trigger: 'change',
                    type:'number',
                  }">
                <Select v-model.trim="form.childrenList[index].applicationSpouseId" style="width:200px">
                  <Option v-for="item in spouseList" :value="item.id" :key="item.id">{{ item.name }}</Option>
                  <Option value="" @click.native="addSpouse('formSpouse','添加',null,index)" style="color:#1890ff;">+ 添加子女{{idcardGetSexInInfo(form.applicantIDCardNo)}} </Option>
                </Select>
                <!-- <Button style="margin-left:10px;" type="warning" icon="ios-add" @click="addSpouse('formSpouse','添加')">添加子女{{idcardGetSexInInfo(form.applicantIDCardNo)}}</Button> -->
              </FormItem>
              </Col>

              <Col span="24" class="childBox_childPage"
                v-if="(form.childrenList[index].childType===$store.state.childTypeEnum['亲生']||form.childrenList[index].childType===$store.state.childTypeEnum['继子女'])&&form.childrenList[index].applicationSpouseId>0">
              <p class="message_child_area">
                <span class="message_child" @click="addSpouse('formSpouse','修改',spouseInfoList[index].id)">
                  <Icon type="md-create" />
                  修改
                  <!-- <Icon type="ios-arrow-forward" /> -->
                </span>
                &nbsp;&nbsp;&nbsp;
                <span class="message_child" style="color:#f16643" @click="delSpouse(spouseInfoList[index].id)">
                  <Icon type="md-trash" />
                  删除
                  <!-- <Icon type="ios-arrow-forward" /> -->
                </span>
              </p>
              <Row>
                <Col span="24">
                <FormItem :label="'申请人与子女'+(idcardGetSexInInfo(form.applicantIDCardNo))+'的婚姻状况'">
                  <RadioGroup v-model.trim="spouseInfoList[index].maritalStatus">
                    <Radio :label="value" v-for="{ text, value } in $store.state.materiaBasicData
                    .maritalStatus" disabled :key="value">{{ text }}</Radio>
                  </RadioGroup>
                </FormItem>
                </Col>
                <Col span="12">
                <FormItem :label="'子女'+(idcardGetSexInInfo(form.applicantIDCardNo))+'姓名'">
                  <Input v-model.trim="spouseInfoList[index].name" disabled placeholder="请输入">
                  </Input>
                </FormItem>
                </Col>
                <Col span="12">
                <FormItem :label="'子女'+(idcardGetSexInInfo(form.applicantIDCardNo))+'身份证'">
                  <Input v-model.trim="spouseInfoList[index].idCardNo" disabled placeholder="请输入">
                  </Input>
                </FormItem>
                </Col>
              </Row>
              <!-- 子女的生母的婚姻状况 已婚时 -->
              <Row v-show="spouseInfoList[index].maritalStatus === $store.state.materiaBasicData.maritalStatusSet['初婚']||spouseInfoList[index].maritalStatus === $store.state.materiaBasicData.maritalStatusSet['再婚']">
                <Col span="12">
                <FormItem :label="'子女'+(idcardGetSexInInfo(form.applicantIDCardNo))+'身份证人像面'">
                  <Row :gutter="16">
                    <Col span="24">
                    <div class="line_area">
                      <!-- 已上传图片 -->
                      <div class="fileList" v-if="spouseInfoList[index].idCardFrontGuid">
                        <!-- <template v-for="(img, img_i) in form.personnelIDCardBackGuid"> -->
                        <span class="pos">
                          <img class="img uploadImage" :src="$baseURL+'/file/cover/'+ spouseInfoList[index].idCardFrontGuid" />
                          <i class="img_magnify">
                            <Icon size="26" class="ico" color="#ffffff" @click="handleView(spouseInfoList[index].idCardFrontGuid)" type="ios-eye" />
                          </i>
                        </span>
                        <!-- </template> -->
                      </div>
                      <div class="fileList" v-else>
                        <span class="pos">
                          <span class="img">
                            <span class="uploadImageNo">
                              <Icon type="ios-image" size="30" />
                            </span>
                          </span>
                        </span>
                      </div>
                    </div>
                    </Col>
                  </Row>
                </FormItem>
                </Col>
                <Col span="12">
                <FormItem :label="'子女'+(idcardGetSexInInfo(form.applicantIDCardNo))+'身份证国徽面'" prop="idCardBackGuid">
                  <Row :gutter="16">
                    <Col span="24">
                    <div class="line_area">
                      <!-- 已上传图片 -->
                      <div class="fileList" v-if="spouseInfoList[index].idCardBackGuid">
                        <!-- <template v-for="(img, img_i) in form.personnelIDCardBackGuid"> -->
                        <span class="pos">
                          <img class="img uploadImage" :src="$baseURL+'/file/cover/'+ spouseInfoList[index].idCardBackGuid" />
                          <i class="img_magnify">
                            <Icon size="26" class="ico" color="#ffffff" @click="handleView(spouseInfoList[index].idCardBackGuid)" type="ios-eye" />
                          </i>
                        </span>
                        <!-- </template> -->
                      </div>
                      <div class="fileList" v-else>
                        <span class="pos">
                          <span class="img">
                            <span class="uploadImageNo">
                              <Icon type="ios-image" size="30" />
                            </span>
                          </span>
                        </span>
                      </div>
                    </div>
                    </Col>
                  </Row>
                </FormItem>
                </Col>
                <Col span="12">
                <FormItem label="持证人结婚证原件">
                  <Row :gutter="16">
                    <Col span="24">
                    <div class="line_area">
                      <!-- 已上传图片 -->
                      <div class="fileList" v-if="spouseInfoList[index].marriageCertificateGuid">
                        <!-- <template v-for="(img, img_i) in form.personnelIDCardBackGuid"> -->
                        <span class="pos">
                          <img class="img uploadImage" :src="$baseURL+'/file/cover/'+ spouseInfoList[index].marriageCertificateGuid" />
                          <i class="img_magnify">
                            <Icon size="26" class="ico" color="#ffffff" @click="handleView(spouseInfoList[index].marriageCertificateGuid)" type="ios-eye" />
                          </i>
                        </span>
                        <!-- </template> -->
                      </div>
                      <div class="fileList" v-else>
                        <span class="pos">
                          <span class="img">
                            <span class="uploadImageNo">
                              <Icon type="ios-image" size="30" />
                            </span>
                          </span>
                        </span>
                      </div>
                    </div>
                    </Col>
                  </Row>
                </FormItem>
                </Col>
              </Row>
              <!-- 子女的生母的婚姻状况 离异时 -->
              <Row v-show="spouseInfoList[index].maritalStatus === $store.state.materiaBasicData.maritalStatusSet['离异']">
                <Col span="24">
                <FormItem :label="'离婚证'" prop="divorceCertificateGuid">
                  <Row :gutter="16">
                    <Col span="24">
                    <div class="line_area">
                      <!-- 已上传图片 -->
                      <div class="fileList" v-if="spouseInfoList[index].divorceCertificateGuid">
                        <!-- <template v-for="(img, img_i) in form.personnelIDCardBackGuid"> -->
                        <span class="pos">
                          <img class="img uploadImage" :src="$baseURL+'/file/cover/'+ spouseInfoList[index].divorceCertificateGuid" />
                          <i class="img_magnify">
                            <Icon size="26" class="ico" color="#ffffff" @click="handleView(spouseInfoList[index].divorceCertificateGuid)" type="ios-eye" />
                          </i>
                        </span>
                        <!-- </template> -->
                      </div>
                      <div class="fileList" v-else>
                        <span class="pos">
                          <span class="img">
                            <span class="uploadImageNo">
                              <Icon type="ios-image" size="30" />
                            </span>
                          </span>
                        </span>
                      </div>
                    </div>
                    </Col>
                  </Row>
                </FormItem>
                </Col>
                <Col span="24">
                <FormItem :label="'离婚协议'">
                  <div class="_link" v-for="file in spouseInfoList[index].divorceSettlementGuidListPreview" @click="handlePreview(file)" :key="file.guid">
                    <Icon :type="file.name | fileType" />
                    {{file.name}}
                  </div>
                  <span class='_noLink' v-if="spouseInfoList[index].divorceSettlementGuidListPreview.length<1">无</span>
                </FormItem>
                </Col>
                <Col span="24">
                <FormItem :label="'法院判决材料'">
                  <div class="_link" v-for="file in spouseInfoList[index].courtJudgmentGuidListPreview" @click="handlePreview(file)" :key="file.guid">
                    <Icon :type="file.name | fileType" />
                    {{file.name}}
                  </div>
                  <span class='_noLink' v-if="spouseInfoList[index].courtJudgmentGuidListPreview.length<1">无</span>
                </FormItem>
                </Col>
                <Col span="24">
                <FormItem :label="'法院调解书'" prop="courtMediationLetterGuid">
                  <div class="_link" v-for="file in spouseInfoList[index].courtMediationLetterGuidListPreview" @click="handlePreview(file)" :key="file.guid">
                    <Icon :type="file.name | fileType" />
                    {{file.name}}
                  </div>
                  <span class='_noLink' v-if="spouseInfoList[index].courtMediationLetterGuidListPreview.length<1">无</span>
                </FormItem>
                </Col>
              </Row>
              <!--子女的生母的婚姻状况 丧偶时  -->
              <Row v-show="spouseInfoList[index].maritalStatus === $store.state.materiaBasicData.maritalStatusSet['丧偶']">
                <Col span="24">
                <FormItem :label="'死亡证明'">
                  <div class="_link" v-for="file in spouseInfoList[index].deathCertificateGuidListPreview" @click="handlePreview(file)" :key="file.guid">
                    <Icon :type="file.name | fileType" />
                    {{file.name}}
                  </div>
                  <span class='_noLink' v-if="spouseInfoList[index].deathCertificateGuidListPreview.length<1">无</span>
                </FormItem>
                </Col>
                <Col span="24">
                <FormItem :label="'户籍注销'">
                  <div class="_link" v-for="file in spouseInfoList[index].domicileCancelGuidListPreview" @click="handlePreview(file)" :key="file.guid">
                    <Icon :type="file.name | fileType" />
                    {{file.name}}
                  </div>
                  <span class='_noLink' v-if="spouseInfoList[index].domicileCancelGuidListPreview.length<1">无</span>
                </FormItem>
                </Col>
              </Row>
              <Row v-if="spouseInfoList[index].maritalStatus === $store.state.materiaBasicData.maritalStatusSet['初婚']||spouseInfoList[index].maritalStatus === $store.state.materiaBasicData.maritalStatusSet['再婚']">
                <Col span="24">
                <FormItem :label="'其他婚姻材料'" prop="spouseOtherMarriageGuidList">
                  <div class="_link" v-for="file in spouseInfoList[index].spouseOtherMarriageGuidListPreview" @click="handlePreview(file)" :key="file.guid">
                    <Icon :type="file.name | fileType" />
                    {{file.name}}
                  </div>
                  <span class='_noLink' v-if="spouseInfoList[index].spouseOtherMarriageGuidListPreview.length<1">无</span>

                </FormItem>
                </Col>
              </Row>
              <Row v-else>
                <Col span="24">
                <FormItem :label="'其他材料'" prop="spouseOtherGuidList">
                  <div class="_link" v-for="file in spouseInfoList[index].spouseOtherGuidListPreview" @click="handlePreview(file)" :key="file.guid">
                    <Icon :type="file.name | fileType" />
                    {{file.name}}
                  </div>
                  <span class='_noLink' v-if="spouseInfoList[index].spouseOtherGuidListPreview.length<1">无</span>

                </FormItem>
                </Col>
              </Row>

              </Col>

            </Row>
            </Col>
            <Col span="24">
            <FormItem :label="'子女' + (index + 1) + '户籍'" :prop="'childrenList[' + index + '].registeredResidenceType'" :rules="{
                required: true,
                message: '请选择',
                type: 'number',
                trigger: 'change',
              }">
              <RadioGroup v-model.trim="form.childrenList[index].registeredResidenceType">
                <Radio :label="value" v-for="{ text, value } in $store.state.materiaBasicData
                    .registeredResidenceType" :key="value">{{ text }}</Radio>
              </RadioGroup>
            </FormItem>
            </Col>
            <Col span="24" v-show="form.childrenList[index].registeredResidenceType===$store.state.registeredResidenceType['集体户口']">
            <FormItem :label="'子女' + (index + 1) + '集体户口类型'" :prop="'childrenList[' + index + '].collectiveAccountMaterialsType'" :rules="{
                required: form.childrenList[index].registeredResidenceType===$store.state.registeredResidenceType['集体户口'],
                message: '请选择',
                type: 'number',
                trigger: 'change',
              }">
              <RadioGroup v-model.trim="form.childrenList[index].collectiveAccountMaterialsType">
                <Radio :label="value" v-for="{ text, value } in $store.state.materiaBasicData
                    .collectiveAccountMaterialsTypes" :key="value">{{ text }}</Radio>
              </RadioGroup>
            </FormItem>
            </Col>
            <Col span="12"
              v-show="form.childrenList[index].registeredResidenceType===$store.state.registeredResidenceType['家庭户口']||(form.childrenList[index].registeredResidenceType===$store.state.registeredResidenceType['集体户口']&&form.childrenList[index].collectiveAccountMaterialsType===$store.state.collectiveAccountMaterialsTypes['户口簿'])">
            <FormItem :label="'上传子女' + (index + 1) + '户口簿详细地址页的首页'" :prop="'childrenList[' + index + '].residenceBookletMainPageGuid'"
              :rules="{ required: form.childrenList[index].registeredResidenceType===$store.state.registeredResidenceType['家庭户口']||(form.childrenList[index].registeredResidenceType===$store.state.registeredResidenceType['集体户口']&&form.childrenList[index].collectiveAccountMaterialsType===$store.state.collectiveAccountMaterialsTypes['户口簿']), message: '请上传', trigger: 'blur' }">
              <Row :gutter="16">
                <Col span="24">
                <div class="line_area">
                  <Upload multiple type="drag" class="uploadImage" :on-progress="( event, file, fileList)=>updateProgress( event, file, fileList,`childrenList${index}residenceBookletMainPageGuidProgress`)" :accept="accept" :format="format"
                    :show-upload-list="false" :data="uploadData" :on-success="
                        (response, file, fileList) =>
                         {$refs[`childrenList${index}residenceBookletMainPageGuidProgress`][0].updateShow(false)
        $refs['childrenList'+index+'residenceBookletMainPageGuidProgressUpload'][0].style.display = 'block'; handleSuccess(
                            response,
                            file,
                            fileList,
                            `childrenList[${index}].residenceBookletMainPageGuid`
                          )}
                      " :on-format-error="handleFormatError" :action="$baseURL + '/common/file/uploadfile'">
                    <div class="uploadBg">
                      <span :ref="'childrenList'+index+'residenceBookletMainPageGuidProgressUpload'">
                        <Icon @click.stop="()=>{return false}" type="ios-add" size="80" style="color: rgba(192, 192, 192,0.5)"></Icon>
                        <div class="upload_btn">
                          <Icon type="ios-folder" />&nbsp;&nbsp;上传电脑图片
                        </div>
                        <div class="upload_btn" @click.stop="openQrCodeUpload( `childrenList[${index}].residenceBookletMainPageGuid`)">
                          <Icon type="ios-camera" />&nbsp;&nbsp;手机拍照上传
                        </div>
                      </span>
                      <progress-bar :ref="'childrenList'+index+'residenceBookletMainPageGuidProgress'"></progress-bar>

                    </div>
                  </Upload>
                  <!-- 已上传图片 -->
                  <div class="fileList" v-if="
                        form.childrenList[index].residenceBookletMainPageGuid
                      ">
                    <!-- <template v-for="(img, img_i) in form.personnelIDCardBackGuid"> -->
                    <span class="pos">
                      <img class="img uploadImage" :src="
                            $baseURL +
                            '/file/cover/' +
                            form.childrenList[index]
                              .residenceBookletMainPageGuid
                          " />
                      <i class="img_magnify">
                        <Icon size="26" class="ico" color="#ffffff" @click="handleView(form.childrenList[index].residenceBookletMainPageGuid)" type="ios-eye" />
                        <Icon size="26" class="ico" color="#ffffff" @click="
                              handleRemove(
                                0,
                                form.childrenList[index]
                                  .residenceBookletMainPageGuid,
                                `childrenList[${index}].residenceBookletMainPageGuid`
                              )
                            " type="ios-trash-outline" />
                      </i>
                    </span>
                    <!-- </template> -->
                  </div>
                  <div class="fileList" v-else>
                    <span class="pos">
                      <span class="img">
                        <span class="uploadImageNo">
                          <Icon type="ios-image" size="30" />
                        </span>
                      </span>
                    </span>
                  </div>
                </div>
                </Col>
              </Row>
            </FormItem>
            </Col>
            <Col span="12"
              v-show="form.childrenList[index].registeredResidenceType===$store.state.registeredResidenceType['家庭户口']||(form.childrenList[index].registeredResidenceType===$store.state.registeredResidenceType['集体户口']&&form.childrenList[index].collectiveAccountMaterialsType===$store.state.collectiveAccountMaterialsTypes['户口簿'])">
            <FormItem :label="'上传子女' + (index + 1) + '户口簿本人信息页'" :prop="'childrenList[' + index + '].residenceBookletSelfPageGuid'"
              :rules="{ required: form.childrenList[index].registeredResidenceType===$store.state.registeredResidenceType['家庭户口']||(form.childrenList[index].registeredResidenceType===$store.state.registeredResidenceType['集体户口']&&form.childrenList[index].collectiveAccountMaterialsType===$store.state.collectiveAccountMaterialsTypes['户口簿']), message: '请上传', trigger: 'blur' }">
              <Row :gutter="16">
                <Col span="24">
                <div class="line_area">
                  <Upload multiple type="drag" class="uploadImage" :on-progress="( event, file, fileList)=>updateProgress( event, file, fileList,`childrenList${index}residenceBookletSelfPageGuidProgress`)" :accept="accept" :format="format"
                    :show-upload-list="false" :data="uploadData" :on-success="
                        (response, file, fileList) =>
                         { $refs[`childrenList${index}residenceBookletSelfPageGuidProgress`][0].updateShow(false)
        $refs['childrenList'+index+'residenceBookletSelfPageGuidProgressUpload'][0].style.display = 'block';handleSuccess(
                            response,
                            file,
                            fileList,
                            `childrenList[${index}].residenceBookletSelfPageGuid`
                          )}
                      " :on-format-error="handleFormatError" :action="$baseURL + '/common/file/uploadfile'">
                    <div class="uploadBg">
                      <span :ref="'childrenList'+index+'residenceBookletSelfPageGuidProgressUpload'">
                        <Icon @click.stop="()=>{return false}" type="ios-add" size="80" style="color: rgba(192, 192, 192,0.5)"></Icon>
                        <div class="upload_btn">
                          <Icon type="ios-folder" />&nbsp;&nbsp;上传电脑图片
                        </div>
                        <div class="upload_btn" @click.stop="openQrCodeUpload( `childrenList[${index}].residenceBookletSelfPageGuid`)">
                          <Icon type="ios-camera" />&nbsp;&nbsp;手机拍照上传
                        </div>
                      </span>
                      <progress-bar :ref="'childrenList'+index+'residenceBookletSelfPageGuidProgress'"></progress-bar>

                    </div>
                  </Upload>
                  <!-- 已上传图片 -->
                  <div class="fileList" v-if="
                        form.childrenList[index].residenceBookletSelfPageGuid
                      ">
                    <span class="pos">
                      <img class="img uploadImage" :src="
                            $baseURL +
                            '/file/cover/' +
                            form.childrenList[index]
                              .residenceBookletSelfPageGuid
                          " />
                      <i class="img_magnify">
                        <Icon size="26" class="ico" color="#ffffff" @click="handleView(form.childrenList[index].residenceBookletSelfPageGuid)" type="ios-eye" />
                        <Icon size="26" class="ico" color="#ffffff" @click="
                              handleRemove(
                                0,
                                form.childrenList[index]
                                  .residenceBookletSelfPageGuid,
                                `childrenList[${index}].residenceBookletSelfPageGuid`
                              )
                            " type="ios-trash-outline" />
                      </i>
                    </span>
                  </div>
                  <div class="fileList" v-else>
                    <span class="pos">
                      <span class="img">
                        <span class="uploadImageNo">
                          <Icon type="ios-image" size="30" />
                        </span>
                      </span>
                    </span>
                  </div>
                </div>
                </Col>
              </Row>
            </FormItem>
            </Col>
            <Col span="12"
              v-show="form.childrenList[index].registeredResidenceType===$store.state.registeredResidenceType['集体户口']&&form.childrenList[index].collectiveAccountMaterialsType===$store.state.collectiveAccountMaterialsTypes['派出所出具的户籍证明']">
            <FormItem :label="'上传子女' + (index + 1) + '派出所出具的户籍证明'" :prop="'childrenList[' + index + '].policeStationRegistrationCertificateGuid'"
              :rules="{ required: form.childrenList[index].registeredResidenceType===$store.state.registeredResidenceType['集体户口']&&form.childrenList[index].collectiveAccountMaterialsType===$store.state.collectiveAccountMaterialsTypes['派出所出具的户籍证明'], message: '请上传', trigger: 'blur' }">
              <Row :gutter="16">
                <Col span="24">
                <div class="line_area">
                  <Upload multiple type="drag" class="uploadImage" :on-progress="( event, file, fileList)=>updateProgress( event, file, fileList,`childrenList${index}policeStationRegistrationCertificateGuidProgress`)" :accept="accept"
                    :format="format" :show-upload-list="false" :data="uploadData" :on-success="
                        (response, file, fileList) =>
                         { $refs[`childrenList${index}policeStationRegistrationCertificateGuidProgress`][0].updateShow(false)
        $refs['childrenList'+index+'policeStationRegistrationCertificateGuidProgressUpload'][0].style.display = 'block';handleSuccess(
                            response,
                            file,
                            fileList,
                            `childrenList[${index}].policeStationRegistrationCertificateGuid`
                          )}
                      " :on-format-error="handleFormatError" :action="$baseURL + '/common/file/uploadfile'">
                    <div class="uploadBg">
                      <span :ref="'childrenList'+index+'policeStationRegistrationCertificateGuidProgressUpload'">
                        <Icon @click.stop="()=>{return false}" type="ios-add" size="80" style="color: rgba(192, 192, 192,0.5)"></Icon>
                        <div class="upload_btn">
                          <Icon type="ios-folder" />&nbsp;&nbsp;上传电脑图片
                        </div>
                        <div class="upload_btn" @click.stop="openQrCodeUpload( `childrenList[${index}].policeStationRegistrationCertificateGuid`)">
                          <Icon type="ios-camera" />&nbsp;&nbsp;手机拍照上传
                        </div>
                      </span>
                      <progress-bar :ref="'childrenList'+index+'policeStationRegistrationCertificateGuidProgress'"></progress-bar>

                    </div>
                  </Upload>
                  <!-- 已上传图片 -->
                  <div class="fileList" v-if="
                        form.childrenList[index].policeStationRegistrationCertificateGuid 
                      ">
                    <span class="pos">
                      <img class="img uploadImage" :src="
                            $baseURL +
                            '/file/cover/' +
                            form.childrenList[index]
                              .policeStationRegistrationCertificateGuid 
                          " />
                      <i class="img_magnify">
                        <Icon size="26" class="ico" color="#ffffff" @click="handleView(form.childrenList[index].policeStationRegistrationCertificateGuid )" type="ios-eye" />
                        <Icon size="26" class="ico" color="#ffffff" @click="
                              handleRemove(
                                0,
                                form.childrenList[index]
                                  .policeStationRegistrationCertificateGuid ,
                                `childrenList[${index}].policeStationRegistrationCertificateGuid`
                              )
                            " type="ios-trash-outline" />
                      </i>
                    </span>
                  </div>
                  <div class="fileList" v-else>
                    <span class="pos">
                      <span class="img">
                        <span class="uploadImageNo">
                          <Icon type="ios-image" size="30" />
                        </span>
                      </span>
                    </span>
                  </div>
                </div>
                </Col>
              </Row>
            </FormItem>
            </Col>
            <Col span="24" v-show="form.childrenList[index].childType !=$store.state.childTypeEnum['领养']">
            <FormItem :label="'上传子女' + (index + 1) + '出生医学证明原件'" :prop="'childrenList[' + index + '].birthCertificateGuid'"
              :rules="{ required: form.childrenList[index].childType !=$store.state.childTypeEnum['领养'], message: '请上传', trigger: 'blur' }">
              <Row :gutter="16">
                <Col span="24">
                <div class="line_area">
                  <Upload multiple type="drag" class="uploadImage" :on-progress="( event, file, fileList)=>updateProgress( event, file, fileList,`childrenList${index}birthCertificateGuidProgress`)" :accept="accept" :format="format"
                    :show-upload-list="false" :data="uploadData" :on-success="
                        (response, file, fileList) =>
                         {$refs[`childrenList${index}birthCertificateGuidProgress`][0].updateShow(false)
        $refs['childrenList'+index+'birthCertificateGuidProgressUpload'][0].style.display = 'block'; handleSuccess(
                            response,
                            file,
                            fileList,
                            `childrenList[${index}].birthCertificateGuid`
                          )}
                      " :on-format-error="handleFormatError" :action="$baseURL + '/common/file/uploadfile'">
                    <div class="uploadBg">
                      <span :ref="'childrenList'+index+'birthCertificateGuidProgressUpload'">
                        <Icon @click.stop="()=>{return false}" type="ios-add" size="80" style="color: rgba(192, 192, 192,0.5)"></Icon>
                        <div class="upload_btn">
                          <Icon type="ios-folder" />&nbsp;&nbsp;上传电脑图片
                        </div>
                        <div class="upload_btn" @click.stop="openQrCodeUpload( `childrenList[${index}].birthCertificateGuid`)">
                          <Icon type="ios-camera" />&nbsp;&nbsp;手机拍照上传
                        </div>
                      </span>
                      <progress-bar :ref="'childrenList'+index+'birthCertificateGuidProgress'"></progress-bar>

                    </div>
                  </Upload>
                  <!-- 已上传图片 -->
                  <div class="fileList" v-if="form.childrenList[index].birthCertificateGuid">
                    <!-- <template v-for="(img, img_i) in form.personnelIDCardBackGuid"> -->
                    <span class="pos">
                      <img class="img uploadImage" :src="
                            $baseURL +
                            '/file/cover/' +
                            form.childrenList[index].birthCertificateGuid
                          " />
                      <i class="img_magnify">
                        <Icon size="26" class="ico" color="#ffffff" @click="handleView(form.childrenList[index].birthCertificateGuid)" type="ios-eye" />
                        <Icon size="26" class="ico" color="#ffffff" @click="
                              handleRemove(
                                0,
                                form.childrenList[index].birthCertificateGuid,
                                `childrenList[${index}].birthCertificateGuid`
                              )
                            " type="ios-trash-outline" />
                      </i>
                    </span>
                    <!-- </template> -->
                  </div>
                  <div class="fileList" v-else>
                    <span class="pos">
                      <span class="img">
                        <span class="uploadImageNo">
                          <Icon type="ios-image" size="30" />
                        </span>
                      </span>
                    </span>
                  </div>
                </div>
                </Col>
              </Row>
            </FormItem>
            </Col>
            <!-- <template v-if="true"> -->
            <Col span="12" v-show="form.childrenList[index].age >= 16">
            <FormItem :label="'上传子女' + (index + 1) + '全日制普通高中就读证明'" :prop="'childrenList[' + index + '].fullTimeHighSchoolGuid'" :rules="{
                required: form.childrenList[index].age >= 16,
                message: '请上传',
                trigger: 'blur',
              }">
              <Row :gutter="16">
                <Col span="24">
                <div class="line_area">
                  <Upload multiple type="drag" class="uploadImage" :on-progress="( event, file, fileList)=>updateProgress( event, file, fileList,`childrenList${index}fullTimeHighSchoolGuidProgress`)" :accept="accept" :format="format"
                    :show-upload-list="false" :data="uploadData" :on-success="
                        (response, file, fileList) =>
                          {$refs[`childrenList${index}fullTimeHighSchoolGuidProgress`][0].updateShow(false)
        $refs['childrenList'+index+'fullTimeHighSchoolGuidProgressUpload'][0].style.display = 'block';handleSuccess(
                            response,
                            file,
                            fileList,
                            `childrenList[${index}].fullTimeHighSchoolGuid`
                          )}
                      " :on-format-error="handleFormatError" :action="$baseURL + '/common/file/uploadfile'">
                    <div class="uploadBg">
                      <span :ref="'childrenList'+index+'fullTimeHighSchoolGuidProgressUpload'">
                        <Icon @click.stop="()=>{return false}" type="ios-add" size="80" style="color: rgba(192, 192, 192,0.5)"></Icon>
                        <div class="upload_btn">
                          <Icon type="ios-folder" />&nbsp;&nbsp;上传电脑图片
                        </div>
                        <div class="upload_btn" @click.stop="openQrCodeUpload( `childrenList[${index}].fullTimeHighSchoolGuid`)">
                          <Icon type="ios-camera" />&nbsp;&nbsp;手机拍照上传
                        </div>
                      </span>
                      <progress-bar :ref="'childrenList'+index+'fullTimeHighSchoolGuidProgress'"></progress-bar>

                    </div>
                  </Upload>
                  <!-- 已上传图片 -->
                  <div class="fileList" v-if="form.childrenList[index].fullTimeHighSchoolGuid">
                    <!-- <template v-for="(img, img_i) in form.personnelIDCardBackGuid"> -->
                    <span class="pos">
                      <img class="img uploadImage" :src="
                            $baseURL +
                            '/file/cover/' +
                            form.childrenList[index].fullTimeHighSchoolGuid
                          " />
                      <i class="img_magnify">
                        <Icon size="26" class="ico" color="#ffffff" @click="handleView(form.childrenList[index].fullTimeHighSchoolGuid)" type="ios-eye" />
                        <Icon size="26" class="ico" color="#ffffff" @click="
                              handleRemove(
                                0,
                                form.childrenList[index].fullTimeHighSchoolGuid,
                                `childrenList[${index}].fullTimeHighSchoolGuid`
                              )
                            " type="ios-trash-outline" />
                      </i>
                    </span>
                    <!-- </template> -->
                  </div>
                  <div class="fileList" v-else>
                    <span class="pos">
                      <span class="img">
                        <span class="uploadImageNo">
                          <Icon type="ios-image" size="30" />
                        </span>
                      </span>
                    </span>
                  </div>
                </div>
                </Col>
              </Row>
            </FormItem>
            </Col>
            <Col span="12" v-show="form.childrenList[index].age >= 16">
            <FormItem :label="'上传子女' + (index + 1) + '学籍证明原件'" :prop="'childrenList[' + index + '].studentCertificateGuid'" :rules="{
                required: form.childrenList[index].age >= 16,
                message: '请上传',
                trigger: 'blur',
              }">
              <Row :gutter="16">
                <Col span="24">
                <div class="line_area">
                  <Upload multiple type="drag" class="uploadImage" :on-progress="( event, file, fileList)=>updateProgress( event, file, fileList,`childrenList${index}studentCertificateGuidProgress`)" :accept="accept" :format="format"
                    :show-upload-list="false" :data="uploadData" :on-success="
                        (response, file, fileList) =>
                          {$refs[`childrenList${index}studentCertificateGuidProgress`][0].updateShow(false)
        $refs['childrenList'+index+'studentCertificateGuidProgressUpload'][0].style.display = 'block';handleSuccess(response, file, fileList,  `childrenList[${index}].studentCertificateGuid`)}
                      " :on-format-error="handleFormatError" :action="$baseURL + '/common/file/uploadfile'">
                    <div class="uploadBg">
                      <span :ref="'childrenList'+index+'studentCertificateGuidProgressUpload'">
                        <Icon @click.stop="()=>{return false}" type="ios-add" size="80" style="color: rgba(192, 192, 192,0.5)"></Icon>
                        <div class="upload_btn">
                          <Icon type="ios-folder" />&nbsp;&nbsp;上传电脑图片
                        </div>
                        <div class="upload_btn" @click.stop="openQrCodeUpload( `childrenList[${index}].studentCertificateGuid`)">
                          <Icon type="ios-camera" />&nbsp;&nbsp;手机拍照上传
                        </div>
                      </span>
                      <progress-bar :ref="'childrenList'+index+'studentCertificateGuidProgress'"></progress-bar>

                    </div>
                  </Upload>
                  <!-- 已上传图片 -->
                  <div class="fileList" v-if="form.childrenList[index].studentCertificateGuid">
                    <!-- <template v-for="(img, img_i) in form.personnelIDCardBackGuid"> -->
                    <span class="pos">
                      <img class="img uploadImage" :src="$baseURL + '/file/cover/' +  form.childrenList[index].studentCertificateGuid" />
                      <i class="img_magnify">
                        <Icon size="26" class="ico" color="#ffffff" @click="handleView(form.childrenList[index].studentCertificateGuid)" type="ios-eye" />
                        <Icon size="26" class="ico" color="#ffffff" @click="
                              handleRemove(
                                0,
                                form.childrenList[index].studentCertificateGuid,
                                `childrenList[${index}].studentCertificateGuid`
                              )
                            " type="ios-trash-outline" />
                      </i>
                    </span>
                    <!-- </template> -->
                  </div>
                  <div class="fileList" v-else>
                    <span class="pos">
                      <span class="img">
                        <span class="uploadImageNo">
                          <Icon type="ios-image" size="30" />
                        </span>
                      </span>
                    </span>
                  </div>
                </div>
                </Col>
              </Row>
            </FormItem>
            </Col>
            <Col span="24">
            <FormItem :label="'子女' + (index + 1) + '的其他材料'">
              <Upload :show-upload-list="false" :default-file-list="form.childrenList[ index ].otherMaterialGuidListPreview" :on-preview="handlePreview" :action="$baseURL + '/common/file/uploadfile'" :data="uploadData" :on-remove="
                  (file, fileList) =>
                    handleRemove(
                      file,
                      fileList,
                      `childrenList[${index}].otherMaterialGuidList`,true
                    )
                " :on-success="
                  (response, file, fileList) =>
                    handleSuccess(
                      response,
                      file,
                      fileList,
                      `childrenList[${index}].otherMaterialGuidList`,true
                    )
                " :on-format-error="handleFormatError">
                <Button icon="ios-folder">上传电脑文件</Button>&nbsp;
                <Button icon="ios-camera" @click.stop="openQrCodeUpload(`childrenList[${index}].otherMaterialGuidList`,true)">手机拍照上传</Button>

              </Upload>
              <div class="_linkdel" v-for="file in form.childrenList[ index ].otherMaterialGuidListPreview" :key="file.guid">
                <div class="fileCentent" @click="handlePreview(file)">
                  <Icon :type="file.name | fileType" />
                  {{file.name?file.name:file.fileName}}
                </div>
                <div class="fileDel">
                  <Icon type="md-close" @click="handleRemove(file, null, `childrenList[${index}].otherMaterialGuidList`,true)" />
                </div>
              </div>
            </FormItem>
            </Col>
          </Row>
        </div>
      </template>
      <Button type="warning" @click="addChild('childrenList')" icon="md-add">添加子女</Button>
      <div class="bom_btn">
        <div>
          <Button @click="next(null, current_index - 1)">上一步</Button>
          <Button type="warning" @click="submitStore()">暂存</Button>
          <Button type="primary" @click="next('form' + current)">下一步</Button>
        </div>
      </div>
    </Form>

    <!-- 添加配偶 *如是离异，配偶姓名应显示子女父母姓名，配偶身份证号子女父母身份证;丧偶（提交死亡证/户籍注销）;未婚选择，如果要上传材料就在其他材料里面上传上来。 -->
    <div>
      <Modal v-model="modalShow" width="1260" :title="spouseType+'子女'+(idcardGetSexInInfo(form.applicantIDCardNo))+'信息'">
        <Form ref="formSpouse" :model="formSpouse" :rules="rules" :label-width="155">
          <Row>
            <Col span="24">
            <FormItem :label="'申请人与子女'+(idcardGetSexInInfo(form.applicantIDCardNo))+'的婚姻状况'" prop="maritalStatus" :rules="{
                  required: true,
                  message: '请选择',
                  trigger: 'change',
                  type:'number',
                }">
              <RadioGroup v-model.trim="formSpouse.maritalStatus">
                <Radio :label="value" v-for="{ text, value } in $store.state.materiaBasicData
                    .maritalStatus" :disabled="value== $store.state.maritalStatusSet.初婚||value== $store.state.maritalStatusSet.再婚" :key="value">{{ text }}</Radio>
              </RadioGroup>
            </FormItem>
            </Col>
            <template v-if="formSpouse.maritalStatus === $store.state.materiaBasicData.maritalStatusSet['初婚']||formSpouse.maritalStatus === $store.state.materiaBasicData.maritalStatusSet['再婚']">
              <Col span="12">
              <FormItem :label="'上传子女'+(idcardGetSexInInfo(form.applicantIDCardNo))+'身份证人像面'" prop="idCardFrontGuid" :rules="{
                  required: formSpouse.maritalStatus === $store.state.materiaBasicData.maritalStatusSet['初婚']||formSpouse.maritalStatus === $store.state.materiaBasicData.maritalStatusSet['再婚'],
                  message: '请上传',
                  trigger: 'change',
                }">
                <Row :gutter="16">
                  <Col span="24">
                  <div class="line_area">
                    <Upload multiple type="drag" class="uploadImage" :max-size="1024" :on-exceeded-size="handleMaxSize" :on-progress="( event, file, fileList)=>updateProgress( event, file, fileList,'idCardFrontGuidProgress')"
                      :accept="accept" :format='format' :show-upload-list='false' :data="{ readIdInfo: true }" :on-success="(response, file, fileList)=>{$refs['idCardFrontGuidProgress'].updateShow(false)
        $refs['idCardFrontGuidProgressUpload'].style.display = 'block';handleSuccessSpouse(response, file, fileList,'idCardFrontGuid',false,'spouseIdCard',[{name:'name',},{idCard:'idCardNo'}])}" :on-format-error="handleFormatError"
                      :action="$baseURL+'/common/file/uploadfile'">
                      <div class="uploadBg">
                        <span ref="idCardFrontGuidProgressUpload">
                          <Icon @click.stop="()=>{return false}" type="ios-add" size="80" style="color: rgba(192, 192, 192,0.5)"></Icon>
                          <div class="upload_btn">
                            <Icon type="ios-folder" />&nbsp;&nbsp;上传电脑图片
                          </div>
                          <div class="upload_btn" @click.stop="openQrCodeUploadSpouse('idCardFrontGuid',false,'spouseIdCard',[{name:'name',},{idCard:'idCardNo'}])">
                            <Icon type="ios-camera" />&nbsp;&nbsp;手机拍照上传
                          </div>
                        </span>
                        <progress-bar ref="idCardFrontGuidProgress"></progress-bar>

                      </div>
                    </Upload>
                    <!-- 已上传图片 -->
                    <div class="fileList" v-if="formSpouse.idCardFrontGuid">
                      <!-- <template v-for="(img, img_i) in form.personnelIDCardBackGuid"> -->
                      <span class="pos">
                        <img class="img uploadImage" :src="$baseURL+'/file/cover/'+ formSpouse.idCardFrontGuid" />
                        <i class="img_magnify">
                          <Icon size="26" class="ico" color="#ffffff" @click="handleView(formSpouse.idCardFrontGuid)" type="ios-eye" />
                          <Icon size="26" class="ico" color="#ffffff" @click="handleRemoveSpouse(0,idCardFrontGuid,'idCardFrontGuid')" type="ios-trash-outline" />
                        </i>
                      </span>
                      <!-- </template> -->
                    </div>
                    <div class="fileList" v-else>
                      <span class="pos">
                        <span class="img">
                          <span class="uploadImageNo">
                            <Icon type="ios-image" size="30" />
                          </span>
                        </span>
                      </span>
                    </div>
                  </div>
                  </Col>
                </Row>
              </FormItem>
              </Col>
              <Col span="12">
              <FormItem :label="'上传子女'+(idcardGetSexInInfo(form.applicantIDCardNo))+'身份证国徽面'" prop="idCardBackGuid" :rules="{
                  required: formSpouse.maritalStatus === $store.state.materiaBasicData.maritalStatusSet['初婚']||formSpouse.maritalStatus === $store.state.materiaBasicData.maritalStatusSet['再婚'],
                  message: '请上传',
                  trigger: 'change',
                }">
                <Row :gutter="16">
                  <Col span="24">
                  <div class="line_area">
                    <Upload multiple type="drag" class="uploadImage" :on-progress="( event, file, fileList)=>updateProgress( event, file, fileList,'idCardBackGuidProgress')" :accept="accept" :format='format' :show-upload-list='false'
                      :data="uploadData" :on-success="(response, file, fileList)=>{$refs['idCardBackGuidProgress'].updateShow(false)
        $refs['idCardBackGuidProgressUpload'].style.display = 'block';handleSuccessSpouse(response, file, fileList,'idCardBackGuid')}" :on-format-error="handleFormatError" :action="$baseURL+'/common/file/uploadfile'">
                      <div class="uploadBg">
                        <span ref="idCardBackGuidProgressUpload">
                          <Icon @click.stop="()=>{return false}" type="ios-add" size="80" style="color: rgba(192, 192, 192,0.5)"></Icon>
                          <div class="upload_btn">
                            <Icon type="ios-folder" />&nbsp;&nbsp;上传电脑图片
                          </div>
                          <div class="upload_btn" @click.stop="openQrCodeUploadSpouse('idCardBackGuid',false,'idcard_back')">
                            <Icon type="ios-camera" />&nbsp;&nbsp;手机拍照上传
                          </div>
                        </span>
                        <progress-bar ref="idCardBackGuidProgress"></progress-bar>

                      </div>
                    </Upload>
                    <!-- 已上传图片 -->
                    <div class="fileList" v-if="formSpouse.idCardBackGuid">
                      <!-- <template v-for="(img, img_i) in form.personnelIDCardBackGuid"> -->
                      <span class="pos">
                        <img class="img uploadImage" :src="$baseURL+'/file/cover/'+ formSpouse.idCardBackGuid" />
                        <i class="img_magnify">
                          <Icon size="26" class="ico" color="#ffffff" @click="handleView(formSpouse.idCardBackGuid)" type="ios-eye" />
                          <Icon size="26" class="ico" color="#ffffff" @click="handleRemoveSpouse(0,idCardBackGuid,'idCardBackGuid')" type="ios-trash-outline" />
                        </i>
                      </span>
                      <!-- </template> -->
                    </div>
                    <div class="fileList" v-else>
                      <span class="pos">
                        <span class="img">
                          <span class="uploadImageNo">
                            <Icon type="ios-image" size="30" />
                          </span>
                        </span>
                      </span>
                    </div>
                  </div>
                  </Col>
                </Row>
              </FormItem>
              </Col>
            </template>
            <Col span="12">
            <FormItem :label="'子女'+(idcardGetSexInInfo(form.applicantIDCardNo))+'姓名'" prop="name" :rules="{
                    required:true,
                    message: '请输入',
                    trigger: 'change',
                  }">
              <Input v-model.trim="formSpouse.name" :maxlength="40" placeholder="请输入">
              </Input>
            </FormItem>
            </Col>
            <Col span="12">
            <FormItem :label="'子女'+(idcardGetSexInInfo(form.applicantIDCardNo))+'身份证'" prop="idCardNo"
              :rules="[{ required:  formSpouse.maritalStatus !== $store.state.materiaBasicData.maritalStatusSet['未婚'], message: '请输入', trigger: 'change' },{ pattern: /^[1-9]\d{5}(18|19|20)\d{2}((0[1-9])|(1[0-2]))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/,message: '请输入正确的身份证号', trigger: 'blur' }]">
              <Input v-model.trim="formSpouse.idCardNo" :maxlength="40" placeholder="请输入">
              </Input>
            </FormItem>
            </Col>
            <!-- 子女的生母的婚姻状况 已婚时 -->
            <!-- <Row v-show="formSpouse.maritalStatus === $store.state.materiaBasicData.maritalStatusSet['初婚']||formSpouse.maritalStatus === $store.state.materiaBasicData.maritalStatusSet['再婚']"> -->

            <Col span="12" v-show="formSpouse.maritalStatus === $store.state.materiaBasicData.maritalStatusSet['初婚']||formSpouse.maritalStatus === $store.state.materiaBasicData.maritalStatusSet['再婚']">
            <FormItem label="上传持证人结婚证原件" prop="marriageCertificateGuid" :rules="{
                  required: formSpouse.maritalStatus === $store.state.materiaBasicData.maritalStatusSet['初婚']||formSpouse.maritalStatus === $store.state.materiaBasicData.maritalStatusSet['再婚'],
                  message: '请上传',
                  trigger: 'change',
                }">
              <Row :gutter="16">
                <Col span="24">
                <div class="line_area">
                  <Upload multiple type="drag" class="uploadImage" :on-progress="( event, file, fileList)=>updateProgress( event, file, fileList,'marriageCertificateGuidProgress')" :accept="accept" :format='format' :show-upload-list='false'
                    :data="uploadData" :on-success="(response, file, fileList)=>{$refs['marriageCertificateGuidProgress'].updateShow(false)
        $refs['marriageCertificateGuidProgressUpload'].style.display = 'block';handleSuccessSpouse(response, file, fileList,'marriageCertificateGuid')}" :on-format-error="handleFormatError" :action="$baseURL+'/common/file/uploadfile'">
                    <div class="uploadBg">
                      <span ref="marriageCertificateGuidProgressUpload">
                        <Icon @click.stop="()=>{return false}" type="ios-add" size="80" style="color: rgba(192, 192, 192,0.5)"></Icon>
                        <div class="upload_btn">
                          <Icon type="ios-folder" />&nbsp;&nbsp;上传电脑图片
                        </div>
                        <div class="upload_btn" @click.stop="openQrCodeUploadSpouse('marriageCertificateGuid')">
                          <Icon type="ios-camera" />&nbsp;&nbsp;手机拍照上传
                        </div>
                      </span>
                      <progress-bar ref="marriageCertificateGuidProgress"></progress-bar>

                    </div>
                  </Upload>
                  <!-- 已上传图片 -->
                  <div class="fileList" v-if="formSpouse.marriageCertificateGuid">
                    <!-- <template v-for="(img, img_i) in form.personnelIDCardBackGuid"> -->
                    <span class="pos">
                      <img class="img uploadImage" :src="$baseURL+'/file/cover/'+ formSpouse.marriageCertificateGuid" />
                      <i class="img_magnify">
                        <Icon size="26" class="ico" color="#ffffff" @click="handleView(formSpouse.marriageCertificateGuid)" type="ios-eye" />
                        <Icon size="26" class="ico" color="#ffffff" @click="handleRemoveSpouse(0,marriageCertificateGuid,'marriageCertificateGuid')" type="ios-trash-outline" />
                      </i>
                    </span>
                    <!-- </template> -->
                  </div>
                  <div class="fileList" v-else>
                    <span class="pos">
                      <span class="img">
                        <span class="uploadImageNo">
                          <Icon type="ios-image" size="30" />
                        </span>
                      </span>
                    </span>
                  </div>
                </div>
                </Col>
              </Row>
            </FormItem>
            </Col>
            <!-- </Row> -->
            <!-- 子女的生母的婚姻状况 离异时 *离异材料为 离婚证+离婚协议、法院判决书、法院调解书，三选一。-->
            <Row v-show="formSpouse.maritalStatus === $store.state.materiaBasicData.maritalStatusSet['离异']">
              <Col span="24">
              <FormItem :label="'离婚证'" prop="divorceCertificateGuid">
                <Row :gutter="16">
                  <Col span="24">
                  <div class="line_area">
                    <Upload multiple type="drag" class="uploadImage" :on-progress="( event, file, fileList)=>updateProgress( event, file, fileList,'divorceCertificateGuidProgress')" :accept="accept" :format='format'
                      :show-upload-list='false' :data="uploadData" :on-success="(response, file, fileList)=>{$refs['divorceCertificateGuidProgress'].updateShow(false)
        $refs['divorceCertificateGuidProgressUpload'].style.display = 'block';handleSuccessSpouse(response, file, fileList,'divorceCertificateGuid')}" :on-format-error="handleFormatError" :action="$baseURL+'/common/file/uploadfile'">
                      <div class="uploadBg">
                        <span ref="divorceCertificateGuidProgressUpload">
                          <Icon @click.stop="()=>{return false}" type="ios-add" size="80" style="color: rgba(192, 192, 192,0.5)"></Icon>
                          <div class="upload_btn">
                            <Icon type="ios-folder" />&nbsp;&nbsp;上传电脑图片
                          </div>
                          <div class="upload_btn" @click.stop="openQrCodeUploadSpouse('divorceCertificateGuid')">
                            <Icon type="ios-camera" />&nbsp;&nbsp;手机拍照上传
                          </div>
                        </span>
                        <progress-bar ref="divorceCertificateGuidProgress"></progress-bar>

                      </div>
                    </Upload>
                    <!-- 已上传图片 -->
                    <div class="fileList" v-if="formSpouse.divorceCertificateGuid">
                      <!-- <template v-for="(img, img_i) in form.personnelIDCardBackGuid"> -->
                      <span class="pos">
                        <img class="img uploadImage" :src="$baseURL+'/file/cover/'+ formSpouse.divorceCertificateGuid" />
                        <i class="img_magnify">
                          <Icon size="26" class="ico" color="#ffffff" @click="handleView(formSpouse.divorceCertificateGuid)" type="ios-eye" />
                          <Icon size="26" class="ico" color="#ffffff" @click="handleRemoveSpouse(0,'divorceCertificateGuid','divorceCertificateGuid')" type="ios-trash-outline" />
                        </i>
                      </span>
                      <!-- </template> -->
                    </div>
                    <div class="fileList" v-else>
                      <span class="pos">
                        <span class="img">
                          <span class="uploadImageNo">
                            <Icon type="ios-image" size="30" />
                          </span>
                        </span>
                      </span>
                    </div>
                  </div>
                  </Col>
                </Row>
              </FormItem>
              </Col>
              <Col span="24">
              <FormItem :label="'离婚协议'" prop="divorceSettlementGuidList">
                <Upload :show-upload-list="false" :accept="$store.state.globalAccept" :format="$store.state.globalFormat" :default-file-list="formSpouse.divorceSettlementGuidListPreview" :on-preview="handlePreview"
                  :action="$baseURL + '/common/file/uploadfile'" :data="uploadData" :on-remove="
                      (file, fileList) =>
                        handleRemoveSpouse(
                          file,
                          fileList,
                          `divorceSettlementGuidList`,true
                        )
                    " :on-success="
                      (response, file, fileList) =>
                        handleSuccessSpouse(
                          response,
                          file,
                          fileList,
                          `divorceSettlementGuidList`,true
                        )
                    " :on-format-error="handleFormatError">
                  <Button icon="ios-folder">上传电脑文件</Button>&nbsp;
                  <Button icon="ios-camera" @click.stop="openQrCodeUploadSpouse(`divorceSettlementGuidList`,true)">手机拍照上传</Button>

                </Upload>
                <div class="_linkdel" v-for="file in formSpouse.divorceSettlementGuidListPreview" :key="file.guid">
                  <div class="fileCentent" @click="handlePreview(file)">
                    <Icon :type="file.name | fileType" />
                    {{file.name?file.name:file.fileName}}
                  </div>
                  <div class="fileDel">
                    <Icon type="md-close" @click="handleRemoveSpouse(file, null, 'divorceSettlementGuidList',true)" />
                  </div>
                </div>
              </FormItem>
              </Col>
              <Col span="24">
              <FormItem :label="'法院判决材料'" prop="courtJudgmentGuidList">
                <Upload :show-upload-list="false" :accept="$store.state.globalAccept" :format="$store.state.globalFormat" :default-file-list="formSpouse.courtJudgmentGuidListPreview" :on-preview="handlePreview"
                  :action="$baseURL + '/common/file/uploadfile'" :data="uploadData" :on-remove="
                      (file, fileList) =>
                        handleRemoveSpouse(
                          file,
                          fileList,
                          `courtJudgmentGuidList`,true
                        )
                    " :on-success="
                      (response, file, fileList) =>
                        handleSuccessSpouse(
                          response,
                          file,
                          fileList,
                          `courtJudgmentGuidList`,true
                        )
                    " :on-format-error="handleFormatError">
                  <Button icon="ios-folder">上传电脑文件</Button>&nbsp;
                  <Button icon="ios-camera" @click.stop="openQrCodeUploadSpouse(`courtJudgmentGuidList`,true)">手机拍照上传</Button>
                </Upload>
                <div class="_linkdel" v-for="file in formSpouse.courtJudgmentGuidListPreview" :key="file.guid">
                  <div class="fileCentent" @click="handlePreview(file)">
                    <Icon :type="file.name | fileType" />
                    {{file.name?file.name:file.fileName}}
                  </div>
                  <div class="fileDel">
                    <Icon type="md-close" @click="handleRemoveSpouse(file, null, 'courtJudgmentGuidList',true)" />
                  </div>
                </div>
              </FormItem>
              </Col>
              <Col span="24">
              <FormItem :label="'法院调解书'" prop="courtMediationLetterGuidList">
                <Upload :show-upload-list="false" :accept="$store.state.globalAccept" :format="$store.state.globalFormat" :default-file-list="formSpouse.courtMediationLetterGuidListPreview" :on-preview="handlePreview"
                  :action="$baseURL + '/common/file/uploadfile'" :data="uploadData" :on-remove="
                      (file, fileList) =>
                        handleRemoveSpouse(
                          file,
                          fileList,
                          `courtMediationLetterGuidList`,true
                        )
                    " :on-success="
                      (response, file, fileList) =>
                        handleSuccessSpouse(
                          response,
                          file,
                          fileList,
                          `courtMediationLetterGuidList`,true
                        )
                    " :on-format-error="handleFormatError">
                  <Button icon="ios-folder">上传电脑文件</Button>&nbsp;
                  <Button icon="ios-camera" @click.stop="openQrCodeUploadSpouse(`courtMediationLetterGuidList`,true)">手机拍照上传</Button>
                </Upload>
                <div class="_linkdel" v-for="file in formSpouse.courtMediationLetterGuidListPreview" :key="file.guid">
                  <div class="fileCentent" @click="handlePreview(file)">
                    <Icon :type="file.name | fileType" />
                    {{file.name?file.name:file.fileName}}
                  </div>
                  <div class="fileDel">
                    <Icon type="md-close" @click="handleRemoveSpouse(file, null, 'courtMediationLetterGuidList',true)" />
                  </div>
                </div>
              </FormItem>
              </Col>
            </Row>
            <!--子女的生母的婚姻状况 丧偶时  -->
            <Row v-show="formSpouse.maritalStatus === $store.state.materiaBasicData.maritalStatusSet['丧偶']">
              <Col span="24">
              <FormItem :label="'死亡证明'" prop="deathCertificateGuidList" :rules="{
                  required: formSpouse.maritalStatus === $store.state.materiaBasicData.maritalStatusSet['丧偶'],
                  type:'array',
                  message: '请上传',
                  trigger: 'change',
                }">
                <Upload :show-upload-list="false" :accept="$store.state.globalAccept" :format="$store.state.globalFormat" :default-file-list="formSpouse.deathCertificateGuidListPreview" :on-preview="handlePreview"
                  :action="$baseURL + '/common/file/uploadfile'" :data="uploadData" :on-remove="
                      (file, fileList) =>
                        handleRemoveSpouse(
                          file,
                          fileList,
                          `deathCertificateGuidList`,true
                        )
                    " :on-success="
                      (response, file, fileList) =>
                        handleSuccessSpouse(
                          response,
                          file,
                          fileList,
                          `deathCertificateGuidList`,true
                        )
                    " :on-format-error="handleFormatError">
                  <Button icon="ios-folder">上传电脑文件</Button>&nbsp;
                  <Button icon="ios-camera" @click.stop="openQrCodeUploadSpouse(`deathCertificateGuidList`,true)">手机拍照上传</Button>

                </Upload>
                <div class="_linkdel" v-for="file in formSpouse.deathCertificateGuidListPreview" :key="file.guid">
                  <div class="fileCentent" @click="handlePreview(file)">
                    <Icon :type="file.name | fileType" />
                    {{file.name?file.name:file.fileName}}
                  </div>
                  <div class="fileDel">
                    <Icon type="md-close" @click="handleRemoveSpouse(file, null, 'deathCertificateGuidList',true)" />
                  </div>
                </div>
              </FormItem>
              </Col>
              <Col span="24">
              <FormItem :label="'户籍注销'" prop="domicileCancelGuidList" :rules="{
                  required: formSpouse.maritalStatus === $store.state.materiaBasicData.maritalStatusSet['丧偶'],
                  message: '请上传',
                   type:'array',
                  trigger: 'change',
                }">
                <Upload :show-upload-list="false" :accept="$store.state.globalAccept" :format="$store.state.globalFormat" :default-file-list="formSpouse.domicileCancelGuidListPreview" :on-preview="handlePreview"
                  :action="$baseURL + '/common/file/uploadfile'" :data="uploadData" :on-remove="
                      (file, fileList) =>
                        handleRemoveSpouse(
                          file,
                          fileList,
                          `domicileCancelGuidList`,true
                        )
                    " :on-success="
                      (response, file, fileList) =>
                        handleSuccessSpouse(
                          response,
                          file,
                          fileList,
                          `domicileCancelGuidList`,true
                        )
                    " :on-format-error="handleFormatError">
                  <Button icon="ios-folder">上传电脑文件</Button>&nbsp;
                  <Button icon="ios-camera" @click.stop="openQrCodeUploadSpouse(`domicileCancelGuidList`,true)">手机拍照上传</Button>
                </Upload>
                <div class="_linkdel" v-for="file in formSpouse.domicileCancelGuidListPreview" :key="file.guid">
                  <div class="fileCentent" @click="handlePreview(file)">
                    <Icon :type="file.name | fileType" />
                    {{file.name?file.name:file.fileName}}
                  </div>
                  <div class="fileDel">
                    <Icon type="md-close" @click="handleRemoveSpouse(file, null, 'domicileCancelGuidList',true)" />
                  </div>
                </div>
              </FormItem>
              </Col>
            </Row>
            <Col span="24">
            <FormItem :label="'其他材料'" prop="spouseOtherGuidList">
              <Upload :show-upload-list="false" :accept="$store.state.globalAccept" :format="$store.state.globalFormat" :default-file-list="formSpouse.spouseOtherGuidListPreview" :on-preview="handlePreview"
                :action="$baseURL + '/common/file/uploadfile'" :data="uploadData" :on-remove="
                      (file, fileList) =>
                        handleRemoveSpouse(
                          file,
                          fileList,
                          `spouseOtherGuidList`,true
                        )
                    " :on-success="
                      (response, file, fileList) =>
                        handleSuccessSpouse(
                          response,
                          file,
                          fileList,
                          `spouseOtherGuidList`,true
                        )
                    " :on-format-error="handleFormatError">
                <Button icon="ios-folder">上传电脑文件</Button>&nbsp;
                <Button icon="ios-camera" @click.stop="openQrCodeUploadSpouse(`spouseOtherGuidList`,true)">手机拍照上传</Button>
              </Upload>
              <div class="_linkdel" v-for="file in formSpouse.spouseOtherGuidListPreview" :key="file.guid">
                <div class="fileCentent" @click="handlePreview(file)">
                  <Icon :type="file.name | fileType" />
                  {{file.name?file.name:file.fileName}}
                </div>
                <div class="fileDel">
                  <Icon type="md-close" @click="handleRemoveSpouse(file, null, 'spouseOtherGuidList',true)" />
                </div>
              </div>
            </FormItem>
            </Col>
          </Row>
          <Spin size="large" fix v-if="modalLoading"></Spin>
        </Form>
        <template #footer>
          <!-- <Button type="error" ghost v-show="spouseType!='添加'" @click="delSpouse(formSpouse.id)">删除</Button> -->
          <Button type="primary" ghost @click="addSpouseSubmit('formSpouse')">{{spouseType}}</Button>
        </template>
      </Modal>
    </div>
    <qr-code-upload :show="qrCodeUploadShow" @colse="colseQrCodeUpload" :qrcode="qrCodeUpload" :loading="qrCodeLoading" />

  </div>
</template>
<script>
import QrCodeUpload from '@/components/qrCodeUploadModel/index'
export default {
  props: { form: { type: Object }, current: { type: Number } },
  components: { QrCodeUpload },
  computed: {
    spouseInfoList() {
      let list = []
      let _this = this
      this.form.childrenList.map((el, index) => {
        //为领养时无生父母数据
        if (el.childType == this.$store.state.childTypeEnum['领养']) {
          list.push(null)
          return
        }
        //无生父母信息id时
        if (el.applicationSpouseId <= 0) {
          list.push(null)
          return
        }
        let SpouseIdIndex = _this.spouseList.findIndex((item) => item.id === el.applicationSpouseId)
        list.push(_this.spouseList[SpouseIdIndex])
      })
      return list
    },
  },
  data() {
    return {
      qrCodeUpload: '',
      qrCodeLoading: false,
      qrCodeUploadShow: false,
      timer: null,
      format: ['jpg', 'png', 'jpeg'],
      formSpouse: {
        guid: '',
        name: '',
        idCardNo: '',
        phone: '',
        applicationId: null,
        idCardFrontGuid: '',
        idCardBackGuid: '',
        registeredResidenceType: null,
        maritalStatus: null,
        id: 0,
        domicileCancelGuidListPreview: [],
        domicileCancelGuidList: [],
        divorceSettlementGuidList: [],
        divorceSettlementGuidListPreview: [],
        deathCertificateGuidList: [],
        deathCertificateGuidListPreview: [],
        courtMediationLetterGuidList: [],
        courtMediationLetterGuidListPreview: [],
        courtJudgmentGuidList: [],
        courtJudgmentGuidListPreview: [],
        spouseOtherGuidList: [],
        spouseOtherGuidListPreview: [],
      },
      childSpouseId: -1,
      spouseList: [],
      spouseType: '添加',
      accept: 'image/*',
      modalShow: false,
      modalLoading: true,
      //   form: { id: 'ywlsh_12356789', kh: '新开户', sfzzm: [] },
      uploadData: {},
      jyList: [{ name: '教育类型1', value: '教育类型1' }],
      xxxsList: [{ name: '普通全日制', value: '普通全日制' }],
      xlList: [{ name: '学历1', value: '学历1' }],
      xwList: [{ name: '学位1', value: '学位1' }],
      current_index: this.current,
      appInfoDataType: this.$store.state.appInfoDataType,
      ywlbList: [
        {
          name: '积分新办：年龄+教育背景（高于或等于本科学士）+社保年限',
          value: '积分新办：年龄+教育背景（高于或等于本科学士）+社保年限',
        },
      ],
      rules: {},
      clList: ['rl', 'dw', 'yy', 'sh', 'rl'],
      selectList: [
        { name: '是', value: 1 },
        { name: '否', value: 0 },
      ],
    }
  },
  mounted() {
    let _this = this
    // setTimeout(()=>{_this.getSpouseList()}, 100)
    _this.getSpouseList()
    // this.spouseList = this.form.spouseList
  },
  methods: {
    // 获取子女年龄
    async getChildAge(name, index) {
      this.$refs[name].validateField('childrenList[' + index + '].idCardNo', async (res) => {
        if (res) {
          return
        }
        this.$emit('getAgeByCardId', this.form.childrenList[index].idCardNo, index)
      })
    },
    //获取配偶列表
    async getSpouseList() {
      this.spouseList = []
      let guid = this.form.guid
      let form2 = JSON.stringify(this.form)
      if (!guid) {
        this.spouseList = this.form.spouseList
        return
      }
      let { data } = await this.$Ajax.get('/api/services/app/JZZJFApi/GetApplicationSpouseList', {
        params: { guid },
      })
      if (Array.isArray(data.result)) {
        this.spouseList = data.result
      }
    },
    //下一步
    next(name, val) {
      let _this = this
      //上一步
      if (name === null) {
        // this.$emit('next', val)

        if (
          this.form.applicantMaritalStatus == this.$store.state.maritalStatusSet['初婚'] ||
          this.form.applicantMaritalStatus == this.$store.state.maritalStatusSet['再婚']
        ) {
          _this.$emit('next', _this.appInfoDataType['配偶信息'])
          return
        }
        if (
          this.form.applicantMaritalStatus == this.$store.state.maritalStatusSet['离异'] ||
          this.form.applicantMaritalStatus == this.$store.state.maritalStatusSet['丧偶']
        ) {
          _this.$emit('next', _this.appInfoDataType['申请人婚姻信息'])
          return
        }
        _this.$emit('next', _this.appInfoDataType['申请人基本信息'])
        return
      }
      //下一步
      this.$refs[name].validate((valid) => {
        if (!valid) {
          this.$Message.error('请将信息填写完整')
          return
        }
        let submitUrl = '/api/services/app/JZZJFApi/SaveAppChildrenInfo'
        if (!this.form.hasEducation) {
          _this.$emit('next', _this.appInfoDataType['加分材料'], submitUrl)
          return
        }
        if (this.form.hasEducation) {
          _this.$emit('next', _this.appInfoDataType['学历信息'], submitUrl)
          return
        }
      })
    },
    async submitStore() {
      await this.$emit('submit', '/api/services/app/JZZJFApi/SaveAppChildrenInfo', 0, '保存成功')
    },
    //文件大小超出
    handleMaxSize(file) {
      this.$emit('handleMaxSize', file)
    },
    addSpouse(name, type, id, childSpouseId) {
      this.modalLoading = false
      this.modalShow = true
      this.spouseType = type
      this.childSpouseId = childSpouseId
      this.formSpouse = {
        guid: '',
        name: '',
        idCardNo: '',
        phone: '',
        applicationId: null,
        idCardFrontGuid: '',
        idCardBackGuid: '',
        registeredResidenceType: null,
        maritalStatus: null,
        id: 0,
        domicileCancelGuidListPreview: [],
        domicileCancelGuidList: [],
        divorceSettlementGuidList: [],
        divorceSettlementGuidListPreview: [],
        deathCertificateGuidList: [],
        deathCertificateGuidListPreview: [],
        courtMediationLetterGuidList: [],
        courtMediationLetterGuidListPreview: [],
        courtJudgmentGuidList: [],
        courtJudgmentGuidListPreview: [],
        spouseOtherGuidList: [],
        spouseOtherGuidListPreview: [],
      }
      this.$refs[name].resetFields()
      if (type != '添加') {
        this.modalLoading = true
        this.getSpouseById(id)
      }
    },
    //获取配偶详情
    getSpouseById(id) {
      let index = this.spouseList.findIndex((item) => item.id === id)
      this.formSpouse = JSON.parse(JSON.stringify(this.spouseList[index]))
      this.modalLoading = false
    },
    //  删除配偶信息
    async delSpouse(id) {
      let _this = this
      this.$Modal.confirm({
        title: '提示',
        content: `<p>确认要删除此信息吗？删除后所有选择此配偶的数据需重新选择！</p>`,
        onOk: async () => {
          let { data } = await this.$Ajax.post(
            `/api/services/app/JZZJFApi/DeleteAppSpouseInfo_Children?guid=${this.form.guid}&id=${id}`
          )
          if (!data.success) {
            this.$Message.error({
              content: '删除失败,' + data.error.message,
              background: true,
              duration: 10,
              closable: true,
            })
          } else {
            await _this.$emit('delSpouseChange', id)
            this.$Message.success({
              content: '删除成功',
              background: true,
              duration: 10,
              closable: true,
            })
            this.modalShow = false
            this.getSpouseList()
          }
        },
      })
    },
    //配偶新增
    addSpouseSubmit(name) {
      let _this = this
      this.$refs[name].validate(async (valid) => {
        if (!valid) {
          this.$Message.error('请将信息填写完整')
          return
        }
        let formSpouseSubmit = true
        //离异时 离婚证+离婚协议、法院判决书、法院调解书，三选一
        if (
          this.formSpouse.maritalStatus ===
          this.$store.state.materiaBasicData.maritalStatusSet['离异']
        ) {
          formSpouseSubmit = false
          //离婚证+离婚协议
          if (
            this.formSpouse.divorceCertificateGuid &&
            Array.isArray(this.formSpouse.divorceSettlementGuidList) &&
            this.formSpouse.divorceSettlementGuidList.length > 0
          ) {
            formSpouseSubmit = true
          }
          //法院判决书
          if (
            Array.isArray(this.formSpouse.courtJudgmentGuidList) &&
            this.formSpouse.courtJudgmentGuidList.length > 0
          ) {
            formSpouseSubmit = true
          }
          //法院调解书
          if (
            Array.isArray(this.formSpouse.courtMediationLetterGuidList) &&
            this.formSpouse.courtMediationLetterGuidList.length > 0
          ) {
            formSpouseSubmit = true
          }
        }
        if (!formSpouseSubmit) {
          this.$Message.error({
            content: '离婚证与离婚协议、法院判决书、法院调解书必须上传一个',
            background: true,
            duration: 6,
          })
          return
        }
        this.modalLoading = true
        this.formSpouse.guid = this.form.guid
        try {
          let data = await this.$Ajax.post(
            '/api/services/app/JZZJFApi/SaveAppSpouseInfo_Children',
            this.formSpouse
          )
          this.$Message.success({
            content: '添加成功',
            background: true,
            duration: 6,
          })
          // this.form.childrenList..[this.childSpouseId]
          // _this.form.childrenList[this.childSpouseId].applicationSpouseId=data.data.result.id

          this.modalShow = false
          this.getSpouseList()
          _this.$set(
            _this.form.childrenList[_this.childSpouseId],
            'applicationSpouseId',
            data.data.result.id
          )
        } catch (error) {
          this.modalLoading = false
        }
      })
    },
    openQrCodeUpload(property, isArray, isReadInfo, readIdInfoAfterToView) {
      this.$emit('openQrCodeUpload', property, isArray, isReadInfo, readIdInfoAfterToView)
    },
    getGenderFromID(id) {
      // 根据身份证的第17位判断性别（奇数为男，偶数为女）
      var gender = id.charAt(16)

      if (gender % 2 === 0) {
        return '女'
      } else {
        return '男'
      }
    },

    //配偶上传材料
    handleSuccessSpouse(
      response,
      file,
      fileList,
      property,
      isArray,
      isReadInfo,
      readIdInfoAfterToView
    ) {
      try {
        if (this.$security_EncriptResponse) {
          response = this.$decryptData(response.data)
        }
      } catch {}
      let _this = this
      //身份证信息
      if (isReadInfo === 'idCard' || isReadInfo === 'spouseIdCard') {
        if (!(response.result.idCard && response.result.name)) {
          this.$Modal.error({
            title: '错误',
            content: '身份证图片识别失败，请上传清晰完整的身份证人像面图片！',
          })
          return
        }
        if (isReadInfo === 'spouseIdCard') {
          let applicantSex = this.getGenderFromID(this.form.applicantIDCardNo)

          if (applicantSex == response.result.sex) {
            this.$Modal.error({
              title: '错误',
              content: '配偶身份证不符合实际情况，请重新上传！',
            })
            return
          }
        }
      }
      //身份证背面 先判断
      if (isReadInfo === 'idcard_back') {
        if (response.result.isIDCardBackRecognizeSuccessful === false) {
          this.$Modal.error({
            title: '错误',
            content: '身份证国徽面无法识别，请上传正确清晰的身份证国徽面图片！',
          })
          return
        }
        if (response.result.isIDCardValidityPassed === false) {
          this.$Modal.error({
            title: '错误',
            content: '身份证已过期，不允许申请！',
          })
          return
        }
      }

      // 判断目标是否为数组，并给其赋值或者插入新数据
      if (isArray) {
        // 是数组
        // if (this.form[property] == undefined) {
        if (!Array.isArray(this.formSpouse[property])) {
          //不存在先创建
          this.$set(this.formSpouse, property, [])
          this.$set(this.formSpouse, property + 'Preview', [])
        }
        let isExistGUID = this.formSpouse[property].some(
          (arrele) => arrele === response.result.guid
        )
        //是否存在,已存在不往下执行
        if (isExistGUID) {
          return
        }
        this.formSpouse[property].push(response.result.guid)
        this.formSpouse[property + 'Preview'].push({
          guid: response.result.guid,
          name: response.result.fileName,
          url: response.result.imageUrl,
        })
      } else {
        // 否则直接赋值
        this.$set(this.formSpouse, property, response.result.guid)
        this.form[property + 'Preview'] = []
        if (this.form[property + 'Preview'] != undefined) {
          this.form[property + 'Preview'] = []
          this.form[property + 'Preview'].push({
            guid: response.result.guid,
            name: response.result.fileName,
            url: response.result.imageUrl,
          })
        }
      }
      //是否有身份证人像面信息,居住证信息
      if (
        isReadInfo === 'idCard' ||
        isReadInfo === 'residencePermit' ||
        isReadInfo === 'spouseIdCard'
      ) {
        readIdInfoAfterToView.map((el) => {
          let key = Object.keys(el)[0]
          if (
            key == 'residencePermitExpiryDate' &&
            response.result[key] != null &&
            response.result[key] != ''
          ) {
            response.result[key] = new Date(response.result[key])
          }
          if (response.result[key] != null && response.result[key] != '') {
            this.$set(this.formSpouse, el[key], response.result[key])
          }
        })
      }
    },
    //打开手机上传
    openQrCodeUploadSpouse(property, isArray, isReadInfo, readIdInfoAfterToView) {
      this.qrCodeUpload = ''
      this.qrCodeUploadShow = true
      this.qrCodeLoading = true
      this.getQrCode(property, isArray, isReadInfo, readIdInfoAfterToView)
    },
    //获取上传文件小程序码
    async getQrCode(property, isArray, isReadInfo, readIdInfoAfterToView) {
      let params = {}
      if (isReadInfo === 'idCard' || isReadInfo === 'spouseIdCard') {
        params.fileType = 'idcard_front'
      }
      if (isReadInfo === 'idcard_back') {
        params.fileType = 'idcard_back'
      }
      let { data } = await this.$Ajax.get('/WxApp/GetUploadFileQrcode', {
        params,
      })
      this.qrCodeUpload = data.result.imgBase64String
      this.qrCodeLoading = false
      if (data.result.uploadContextId && data.result.uploadContextId.indexOf('_') > -1) {
        data.result.uploadContextId = data.result.uploadContextId.split('_')[0]
      }
      this.getMiniUpload(
        data.result.uploadContextId,
        property,
        isArray,
        isReadInfo,
        readIdInfoAfterToView
      )
    },
    async getMiniUpload(uploadContextId, property, isArray, isReadInfo, readIdInfoAfterToView) {
      let _this = this
      let params = { uploadContextId }
      if (isReadInfo === 'idCard' || isReadInfo === 'spouseIdCard') {
        params.readIdInfo = true
      }
      if (isReadInfo === 'idcard_back') {
        params.readIdbackAfterUploaded = true
      }
      if (isReadInfo === 'residencePermit') {
        params.readResidencePermit = true
      }
      if (isReadInfo === 'readEducation') {
        params.readEducation = true
      }
      const poll = async () => {
        // try {
        let { data } = await this.$Ajax.get(`/Common/File/GetUploadedFiles`, {
          params,
        })
        let response = {}
        if (data.result.length > 0) {
          //多张时不再获取到就关闭弹窗和轮询,单张时获取到就关闭弹窗和轮询
          if (isArray == false) {
            //单张时只拿一张
            response = {
              result: { ...data.result[0] },
            }
            //添加
            _this.handleSuccessSpouse(
              response,
              null,
              null,
              property,
              isArray,
              isReadInfo,
              readIdInfoAfterToView
            )
            //关闭弹窗和轮询
            _this.colseQrCodeUpload()
            return
          } else {
            //多张时
            //循环
            data.result.map((item) => {
              //添加
              _this.handleSuccessSpouse(
                { result: item }, //这个为了统一格式
                null,
                null,
                property,
                isArray,
                isReadInfo,
                readIdInfoAfterToView
              )
            })
          }
        }
        //弹窗打开时发起下一次轮询
        if (_this.qrCodeUploadShow) {
          _this.timer = setTimeout(poll, 2500)
        }
      }
      poll()
    },
    colseQrCodeUpload() {
      this.qrCodeUploadShow = false
      clearTimeout(this.timer)
      this.timer = null
    },
    //配偶移除材料
    handleRemoveSpouse(file, fileList, property, isArray) {
      let guid = 0
      try {
        if (file.guid) {
          guid = file.guid
        } else if (file.response) {
          guid = file.response.result.guid
        }
      } catch (error) {
        guid = 0
      }
      if (isArray) {
        // 是数组
        let arrIndex = this.formSpouse[property].indexOf(guid)
        //let arrIndex2 = this.formSpouse[property+'Preview'].indexOf(guid)
        if (arrIndex !== -1) {
          this.formSpouse[property].splice(arrIndex, 1)
          this.removeByGuid(this.formSpouse[property + 'Preview'], guid)
        }
      } else {
        // 否则直接赋值
        this.$set(this.formSpouse, property, null)
        this.formSpouse[property + 'Preview'] = []
      }
    },

    addChild(property) {
      this.$emit('addChild', property)
    },
    delChild(property, index) {
      this.$emit('delChild', property, index)
    },

    removeByGuid(arr, guid) {
      const index = arr.findIndex((item) => item.guid === guid)
      if (index !== -1) {
        arr.splice(index, 1)
      }
    },
    //移除文件
    async handleRemove(file, fileList, property, isArray) {
      this.$emit('handleRemove', file, fileList, property, isArray)
    },
    //预览
    handleView(guid) {
      this.$emit('handleView', guid)
    },
    //文件上传成功
    handleSuccess(response, file, fileList, property, isArray) {
      this.$emit('handleSuccess', response, file, fileList, property, isArray)
      try {
        this.$refs['form' + this.current].validateField(property)
      } catch (error) {}
      this.$forceUpdate()
    },
    //文件格式错误
    handleFormatError(file) {
      this.$emit('handleFormatError', file)
    },
    //文件预览
    handlePreview(file) {
      this.$emit('handlePreview', file)
    },
    updateProgress(event, file, fileList, name) {
      // this.percent = fileInfo.percent * 0.01
      if (Array.isArray(this.$refs[name + 'Upload'])) {
        this.$refs[name + 'Upload'][0].style.display = 'none'

        this.$refs[name][0].updateShow(true)
        this.$refs[name][0].updateProgress(Math.round(event.percent)) //=fileInfo.percent * 0.01

        this.$refs[name + 'Upload'][0].show = event.percent == 100
      } else {
        this.$refs[name + 'Upload'].style.display = 'none'

        this.$refs[name].updateShow(true)
        this.$refs[name].updateProgress(Math.round(event.percent)) //=fileInfo.percent * 0.01

        this.$refs[name + 'Upload'].show = event.percent == 100
      }

      // if (event.percent == 100) {
      //   this.$refs[name].updateShow(false)
      //   this.$refs[name + 'Upload'].style.display = 'block'
      // }
    },
    //通过申请人身份证判断子女需要填写的是父亲信息还是母亲信息
    idcardGetSexInInfo(idCard) {
      if (idCard.length !== 18) {
        // 身份证号码长度应为18位
        return '生父/生母'
      }
      var genderCode = idCard.substr(16, 1) // 获取第17位数字
      if (genderCode % 2 === 0) {
        //女
        return '生父'
      } else {
        // 男
        return '生母'
      }
    },
  },
}
</script>